/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Product_Classification_Tag_Group_Enum =
  /** Événement */
  | 'EVENEMENT'
  /** Moments de consommation */
  | 'MOMENTS_CONSOMMATION'
  /** Produits du Monde */
  | 'PRODUITS_DU_MONDE'
  /** Régimes alimentaires */
  | 'REGIMES_ALIMENTAIRES'
  /** Valeurs et engagements */
  | 'VALEURS_ENGAGEMENTS';

export type ProductClassificationTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductClassificationTagsQuery = { product_classification_tag: Array<{ code: string, tag_group: Types.Product_Classification_Tag_Group_Enum }> };


export const ProductClassificationTagsDocument = /*#__PURE__*/ gql`
    query ProductClassificationTags {
  product_classification_tag(order_by: [{tag_group: asc}, {code: asc}]) {
    code
    tag_group
  }
}
    `;

/**
 * __useProductClassificationTagsQuery__
 *
 * To run a query within a React component, call `useProductClassificationTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductClassificationTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductClassificationTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductClassificationTagsQuery(baseOptions?: Apollo.QueryHookOptions<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>(ProductClassificationTagsDocument, options);
      }
export function useProductClassificationTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>(ProductClassificationTagsDocument, options);
        }
// @ts-ignore
export function useProductClassificationTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>;
export function useProductClassificationTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>): Apollo.UseSuspenseQueryResult<ProductClassificationTagsQuery | undefined, ProductClassificationTagsQueryVariables>;
export function useProductClassificationTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>(ProductClassificationTagsDocument, options);
        }
export type ProductClassificationTagsQueryHookResult = ReturnType<typeof useProductClassificationTagsQuery>;
export type ProductClassificationTagsLazyQueryHookResult = ReturnType<typeof useProductClassificationTagsLazyQuery>;
export type ProductClassificationTagsSuspenseQueryHookResult = ReturnType<typeof useProductClassificationTagsSuspenseQuery>;
export type ProductClassificationTagsQueryResult = Apollo.QueryResult<ProductClassificationTagsQuery, ProductClassificationTagsQueryVariables>;